<template>
  <li class="has-sub">
    <a href="javascript:;">
      <b class="caret pull-right"></b>
      <i class="fa fa-podcast"></i>
      <span>Bimbel Online</span>
    </a>
    <ul class="sub-menu">
      <li><router-link to="/paket-mapel">Paket Mata Pelajaran</router-link></li>
      <li><router-link to="/paket-bimbel">Paket Bimbel</router-link></li>
    </ul>
  </li>
</template>
<script>
export default {
  name: 'bimbel-nav'
}
</script>




// WEBPACK FOOTER //
// Navigation.vue?54c017bc